import { ApolloProvider } from 'react-apollo'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'
import ApolloClient from 'apollo-boost'
import React from 'react'
import ReactDOM from 'react-dom'

import AddProduct from './pages/AddProduct'
import AddUser from './pages/AddUser'
import Login from './pages/Login'
import CheckOutItems from './pages/CheckOutItems'
import ImportLabel from './pages/ImportLabel'
import ImportTrackings from './pages/ImportTrackings'
import ItemLabel from './pages/ItemLabel'
import LabelGroup from './pages/LabelGroup'
import LabelGroupAll from './pages/LabelGroupAll'
import Labels from './pages/Labels'
import LabelSummary from './pages/LabelSummary'
import TrackingJandtGroup from './pages/TrackingJandtGroup'
import TrackingJandt from './pages/TrackingJandt'
import ProductGroup from './pages/ProductGroup'
import Products from './pages/Products'
import RaceProduct from './pages/RaceProduct'
import registerServiceWorker from './registerServiceWorker'
import SearchItems from './pages/SearchItems'
import SearchLabels from './pages/SearchLabels'
import SearchRecipients from './pages/SearchRecipients'
import SearchTrackings from './pages/SearchTrackings'
import SearchOrderId from './pages/SearchOrderId'
import SearchBib from './pages/SearchBib'
import SearchEvent from './pages/SearchEvent'

import Users from './pages/Users'
import SellItems from './pages/SellItems'
import ReportTracking from './pages/ReportTracking'
import SendTrackingByFile from './pages/sendtrackingbyfile'

import KerryLabelGroup from './pages/KerryLabelGroup'
import KerryLabel from './pages/KerryLabel'

import FlashLabelGroup from './pages/FlashLabelGroup'
import FlashLabel from './pages/FlashLabel'

const client = new ApolloClient({
  uri: process.env.REACT_APP_TRACKING_GRAPHQL_CLIENT,
})

function PrivateRoute({ children, ...rest }) {
  // check get userId
  var currentUser = localStorage.getItem('uid_user')
  return (
    <Route
      {...rest}
      render={() => {
        return currentUser ? children : <Redirect to={{ pathname: '/Login' }} />
      }}
    />
  )
}

ReactDOM.render(
  <ApolloProvider client={client}>
    <BrowserRouter>
      <Switch>
        <Route path="/login" component={Login} />
        <PrivateRoute>
          <Route path="/search/labels" component={SearchLabels} />
          <Route path="/search/recipients" component={SearchRecipients} />
          <Route path="/search/trackings" component={SearchTrackings} />
          <Route path="/search/events" component={SearchEvent} />
          <Route path="/search/items" component={SearchItems} />
          <Route path="/search/orderids" component={SearchOrderId} />
          <Route path="/search/bibs" component={SearchBib} />
          <Route path="/label/:group" component={Labels} />
          <Route path="/labels" component={LabelGroup} />
          <Route path="/labelgroupall" component={LabelGroupAll} />
          <Route path="/importLabel" component={ImportLabel} />
          <Route path="/importTracking" component={ImportTrackings} />
          <Route path="/sendtrackingbyfile" component={SendTrackingByFile} />
          <Route path="/labelSummary" component={LabelSummary} />
          <Route path="/trackingjandts" component={TrackingJandtGroup} />
          <Route path="/TrackingJandt/:group" component={TrackingJandt} />
          <Route path="/product/:group" component={Products} />
          <Route path="/products" component={ProductGroup} />
          <Route path="/addProduct" component={AddProduct} />
          <Route path="/raceProduct" component={RaceProduct} />
          <Route path="/item" component={ItemLabel} />
          <Route path="/checkout" component={CheckOutItems} />
          <Route path="/users" component={Users} />
          <Route path="/addUser" component={AddUser} />
          <Route path="/sell/items" component={SellItems} />
          <Route path="/reportTracking" component={ReportTracking} />

          <Route path="/kerryLabels" component={KerryLabelGroup} />
          <Route path="/kerryLabel/:group" component={KerryLabel} />

          <Route path="/flashLabels" component={FlashLabelGroup} />
          <Route path="/flashLabel/:group" component={FlashLabel} />

          <Route path="/" exact component={Users} />
        </PrivateRoute>
      </Switch>
    </BrowserRouter>
  </ApolloProvider>,
  document.getElementById('root')
)
registerServiceWorker()

// eslint-disable-next-line
Array.prototype.asyncForEach = async function asyncForEach(fn) {
  for (let i = 0; i < this.length; i++) {
    await fn(this[i], i)
  }
}



// WEBPACK FOOTER //
// ./src/index.js